<template>

    <div id="app" class="app2">
     <!--
       <router-link :to="'/cabina'" class="list-button-sb px-2 flex space-x-2">cabina</router-link>
      <router-link :to="'/login'" class="list-button-sb px-2 flex space-x-2">login</router-link>
      <router-link :to="'/dashboard'" class="list-button-sb px-2 flex space-x-2">dashboard</router-link>
     -->
     <router-view/>
     <DevToolbar v-if="esDev" />
     <ConfirmDialog :dismissableMask="true" />
    </div>
</template>

<script>
import DevToolbar from './components/DevToolbar.vue';

export default {
  name: 'App',
  components: {
    DevToolbar,
  },
  computed: {
    esDev() {
      try {
        return process.env.NODE_ENV === 'development';
      } catch {
        return false;
      }
    },
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>
